<template>
<p>All calibration data are public. Scientific data have a proprietary period
  <span v-if="!policyRules">(usually 1 year)</span>
  <span v-if="policyRules">(check <a href="#" v-on:click.prevent="openModalByRef('modal-data-policy-rules')">Data policy rules</a>)</span>
  during which the files can be downloaded only by the PI (Principal Investigator) of the related program or collaborators authorized by the PI (CoI).
</p>
</template>

<script>
export default {
  data() {
    return {
      policyRules: process.env.HAS_POLICY_RULES === 'true'
    };
  },
  methods: {
    openModalByRef(ref) {
      this.$root.$refs.helpSidebar.openModalByRef(ref);
    }
  }
}
</script>
